import React, { useState } from "react";
import { Card, Typography, Button, Space } from "antd";
import {
  LineChart,
  Line,
  XAxis,
  YAxis,
  CartesianGrid,
  Tooltip,
  Legend,
  ResponsiveContainer,
  BarChart,
  Bar,
} from "recharts";

const { Title } = Typography;

export default function LateComersTracker() {
  // ✅ Sample latecomer data (for last 5 days + today)
  const lateData = {
    BFMS: [5, 3, 4, 2, 6, 3], // 6 values => 5 previous + today
    BVPL: [2, 1, 3, 4, 2, 5],
    BCPL: [1, 3, 2, 3, 1, 4],
  };

  const dates = ["Day-5", "Day-4", "Day-3", "Day-2", "Day-1", "Today"];

  // Format data for chart
  const chartData = dates.map((day, index) => ({
    day,
    BFMS: lateData.BFMS[index],
    BVPL: lateData.BVPL[index],
    BCPL: lateData.BCPL[index],
  }));

  const [view, setView] = useState("today"); // "today" | "history"

  // Filter today's data
  const todayData = Object.keys(lateData).map((org) => ({
    organisation: org,
    lateComers: lateData[org][5],
  }));

  return (
    <>
      <Space
        style={{
          display: "flex",
          justifyContent: "space-between",
          alignItems: "center",
          width: "100%",
          marginBottom: 15,
        }}
      >
        <Title level={4}>Late Comers</Title>

        <Space>
          <Button
            type={view === "today" ? "primary" : "default"}
            onClick={() => setView("today")}
          >
            Today
          </Button>
          <Button
            type={view === "history" ? "primary" : "default"}
            onClick={() => setView("history")}
          >
            Last 5 Days
          </Button>
        </Space>
      </Space>

      {view === "today" ? (
        <ResponsiveContainer width="100%" height={300}>
          <BarChart
            data={todayData}
            margin={{ top: 20, right: 20, left: 10, bottom: 5 }}
          >
            <CartesianGrid strokeDasharray="3 3" />
            <XAxis dataKey="organisation" />
            <YAxis />
            <Tooltip />
            <Bar dataKey="lateComers" fill="#f86666ff" />
          </BarChart>
        </ResponsiveContainer>
      ) : (
        <ResponsiveContainer width="100%" height={300}>
          <LineChart
            data={chartData}
            margin={{ top: 20, right: 20, left: 10, bottom: 5 }}
          >
            <CartesianGrid strokeDasharray="3 3" />
            <XAxis dataKey="day" />
            <YAxis />
            <Tooltip />
            <Legend />
            <Line type="monotone" dataKey="BFMS" stroke="#1890ff" />
            <Line type="monotone" dataKey="BVPL" stroke="#52c41a" />
            <Line type="monotone" dataKey="BCPL" stroke="#eb2f96" />
          </LineChart>
        </ResponsiveContainer>
      )}
    </>
  );
}
